import React, { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { last } from 'rambdax';

// Add type declaration for Datadog RUM
declare global {
  /* eslint-disable-next-line no-unused-vars */
  interface Window {
    DD_RUM?: {
      startView: (options: { name: string, context: any }) => void;
      setUser: (user: {
        email?: string;
        id?: string;
        name?: string;
        [key: string]: any;
      }) => void;
      clearUser: () => void;
    };
  }
}

// This component is used to track page views in Datadog
const DatadogUserTracking: React.FC = () => {
  // Get router state for tracking
  const routerState = useRouterState();

  // Track page views in Datadog
  useEffect(() => {
    const matchedRoute = last(routerState.matches);

    if (window.DD_RUM && window.DD_RUM.startView && matchedRoute) {
      window.DD_RUM.startView({
        name: matchedRoute.fullPath,
        context: { params: matchedRoute.params },
      });
    }
  }, [ routerState.matches ]); // Re-run when location changes

  return null; // nothing to render
};

export default DatadogUserTracking;
